<button
  type="button"
  class="qr-chip-outline"
  [class.qr-chip-outline--selected]="selected"
  [disabled]="isDisabled"
  (click)="toggle()"
>
  <span class="qr-chip-outline__label">{{ config.label }}</span>
</button>
